import { AcceptedFileType } from '@prickle/next-ui';

export const ALLOWD_FILE_TYPES: AcceptedFileType[] = ['zip', 'rar'];
